import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { forwardRef } from 'react';
import { Checkbox } from '../..';
import { CHECKBOX_DEFAULT_SIZE } from '../Checkbox/Checkbox.constants';
import { CHECKBOXGROUP_DEFAULT_DIRECTION, CHECKBOXGROUP_DEFAULT_DISABLED, CHECKBOXGROUP_DEFAULT_MODE } from './CheckboxGroup.constants';
import { CheckboxGroupWrapper } from './CheckboxGroup.styled';
// Component.
// -----------------------------------------------------------------------------
const CheckboxGroup = forwardRef(({ disabled = CHECKBOXGROUP_DEFAULT_DISABLED, direction = CHECKBOXGROUP_DEFAULT_DIRECTION, mode = CHECKBOXGROUP_DEFAULT_MODE, onChange, options, size = CHECKBOX_DEFAULT_SIZE, ...rest }, ref) => options.length === 0 ? null : (_jsx(CheckboxGroupWrapper, { direction: direction, ref: ref, children: options.map((option, index) => (_createElement(Checkbox, { ...((disabled || option.disabled) && { disabled: true }), checked: option.checked, key: `${option.name}-${index}`, label: option.label, mode: mode, onChange: (e) => {
            const newOptions = options.map((option) => ({
                ...option,
                checked: e.currentTarget.name === option.name
                    ? !option.checked
                    : option.checked
            }));
            onChange(e, newOptions);
        }, size: size, ...rest, name: option.name }))) })));
// Component configuration.
// -----------------------------------------------------------------------------
CheckboxGroup.displayName = 'CheckboxGroup';
export default CheckboxGroup;
//# sourceMappingURL=CheckboxGroup.js.map